import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsRecommendedJobsBlock_Box_1 = styled.div`
  margin-inline: ${-gutterWidth / 2}px;
  padding-block: ${gutterWidth / 2}px;
  padding-inline: ${gutterWidth / 2}px;
  background: ${colors.inputGrey};

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    padding-inline: ${gutterWidth}px;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-inline: var(--px-sm);
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-inline: ${-gutterWidth}px;
    padding-block: ${gutterWidth}px;
    padding-inline: var(--px-md);
  }
`;
